// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextArea = require("../common/Components/Form__TextArea.bs.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TMPUIKIT____CssGrid__Jsx3 = require("../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

function PropertyParkingInputFields(props) {
  let onParkingDetailsBlur = props.onParkingDetailsBlur;
  let onParkingDetailsChange = props.onParkingDetailsChange;
  let onParkingSpacesBlur = props.onParkingSpacesBlur;
  let onParkingSpacesChange = props.onParkingSpacesChange;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: [
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 6,
        widthMd: 3,
        children: JsxRuntime.jsx(Form__TextInput.make, {
          labelText: "Parking Spaces",
          optionalText: "optional",
          onChange: event => onParkingSpacesChange(Stdlib_Int.fromString(Form__Helpers.stripNonDigits(event.target.value), undefined)),
          onBlur: param => onParkingSpacesBlur(),
          value: Stdlib_Option.mapOr(props.parkingSpaces, "", parkingSpaces => parkingSpaces.toString())
        })
      }),
      JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        widthMd: 6,
        children: JsxRuntime.jsx(Form__TextArea.make, {
          labelText: "Parking Details",
          optionalText: "optional",
          placeholderText: "e.g. Assigned, deeded, heated garage, level B2",
          onChange: event => onParkingDetailsChange(Form__Helpers.noneIfEmpty(event.target.value)),
          onBlur: param => onParkingDetailsBlur(),
          value: props.parkingDetails,
          rows: 1
        })
      })
    ]
  });
}

let Grid;

let Cell;

let make = PropertyParkingInputFields;

exports.Grid = Grid;
exports.Cell = Cell;
exports.make = make;
/* Form__Helpers Not a pure module */
